import { FireIcon, StarIcon, FlashIcon } from "./icons";

import Flex from "@/kit/antipad-ui/Flex";
import Typography from "@/kit/antipad-ui/Typography";
import { FC } from "react";
import styles from './styles.module.css';

interface GridTitleItemProps {
    icon: 'fire' | 'star' | 'flash' | 'shield';
    title: string;
}
export const GridTitleItem: FC<GridTitleItemProps> = ({ title, icon }) => {
    const renderIcon = () => {
        switch (icon) {
            case 'fire':
                return <FireIcon />
            case 'star':
                return <StarIcon />
            case 'flash':
                return <FlashIcon />
            default:
                return <FireIcon />
        }
    }
    return <Flex  align="center" gap="s" className={styles.item}>
        {renderIcon()}
        <Typography style={{ textOverflow: 'ellipsis' }} variant="2xLarge_heading">{title}</Typography>
    </Flex>
}   